import { Modal } from "~/components/AccountActions/modal.web";
import { MoveSaveForm, MoveSaveFormProps } from "~/components/MoveSave/Form";

export function MoveSaveDialog(
  props: Pick<MoveSaveFormProps, "saveIds" | "srcSpaceId"> & {
    onDismiss: () => void;
  },
) {
  return (
    <Modal onDismiss={props.onDismiss} header="Move Save">
      <MoveSaveForm {...props} onSuccess={props.onDismiss} />
    </Modal>
  );
}
